import React from 'react';
import { CardProviderInterface } from './types';

// @ts-ignore
export default React.createContext<CardProviderInterface>();